function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#494BB5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5313 16.4688C28.125 15.875 28.125 14.9062 27.5313 14.3438L25.6563 12.4688C25.0938 11.875 24.125 11.875 23.5313 12.4688L22.0938 13.9062C21.9688 14.0312 21.9688 14.2812 22.0938 14.4375L25.5625 17.9062C25.7188 18.0312 25.9688 18.0312 26.0938 17.9062L27.5313 16.4688ZM20.875 15.125L12.6563 23.3438L12 27.125C11.9063 27.6562 12.3438 28.0938 12.875 28L16.6563 27.3438L24.875 19.125C25.0313 19 25.0313 18.75 24.875 18.5938L21.4063 15.125C21.25 15 21 15 20.875 15.125ZM14.75 25.25H16.25V26.4062L14.2188 26.75L13.25 25.7812L13.5938 23.75H14.75V25.25Z",
  fill: "white"
});

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.50a5c018.svg";
export { ForwardRef as ReactComponent };